import React, { ReactNode, useMemo } from 'react';
import cx from 'clsx';
import { useTranslation } from 'react-i18next';

import { IconCloseModal } from '@/assets/icon/common';
import { Button } from '@/components';

import { CenterModal } from '../CenterModal';
import style from './index.module.css';

export type CommonModalProps = {
  on?: boolean;
  turnOff?(): void;
  successText?: string;
  buttonText?: ReactNode;
  children?: ReactNode;
  onConfirm?: () => void;
  headerTitle?: ReactNode;
  // hasCancelButton?: boolean;
  buttonClassName?: string;
  confirmButtonClassName?: string;
  buttonColor?: string;
  size?: 'normal' | 'medium' | 'large';
  className?: string;
  shouldCloseOnOverlayClick?: boolean;
  containerClassName?: string;
  hideCloseBtn?: boolean;
  onRequestClose?: () => void;
  hideModalWhenPathChange?: boolean;
  isConfirmDisabled?: boolean;
  isConfirmLoading?: boolean;
  showCancelBtn?: boolean;
  cancelBtnText?: string;
  cancelButtonClassName?: string;
  overlayClassName?: string;
};

const _CommonModal = ({
  on = true,
  shouldCloseOnOverlayClick = true,
  turnOff,
  buttonText,
  children,
  // hasCancelButton,
  buttonClassName,
  confirmButtonClassName,
  onConfirm,
  headerTitle,
  size = 'normal',
  className,
  containerClassName,
  buttonColor = 'default',
  hideCloseBtn,
  onRequestClose,
  isConfirmDisabled,
  isConfirmLoading,
  showCancelBtn,
  cancelBtnText = '',
  cancelButtonClassName,
  overlayClassName,
}: CommonModalProps) => {
  const { t } = useTranslation();

  const buttonClassNameList = useMemo(
    () => [style.modalButton, buttonClassName],
    [buttonClassName],
  );

  return (
    <CenterModal
      className={cx(style.commonModal, className)}
      style={{
        overlay: {
          backgroundColor: 'rgba(var(--color-black-rgba), 0.3)',
        },
      }}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      isOpen={on}
      shouldFocusAfterRender={false}
      onRequestClose={onRequestClose || turnOff}
      overlayClassName={overlayClassName}>
      <div
        className={cx(
          style.container,
          containerClassName,
          'component-common-modal-container',
          size === 'large' ? style.bigSize : null,
          size === 'medium' ? style.mediumSize : null,
        )}>
        {headerTitle ? (
          <div className={style.modalHeader}>
            <span className={style.title}>{headerTitle}</span>
          </div>
        ) : null}
        {children}
        {onConfirm ? (
          <div className={style.modalFooter}>
            {showCancelBtn ? (
              <Button
                type="default"
                onClick={turnOff}
                className={cx(...buttonClassNameList, cancelButtonClassName)}>
                {cancelBtnText || t('L2PayModal.x9d2fu')}
              </Button>
            ) : null}
            <Button
              type="primary"
              className={cx(...buttonClassNameList, confirmButtonClassName)}
              onClick={onConfirm}
              disabled={isConfirmDisabled}
              loading={isConfirmLoading}>
              {buttonText || t('ResetKeyModal.confirm')}
            </Button>
          </div>
        ) : null}
      </div>
      {hideCloseBtn ? null : (
        <div className={style.bottomWrapper}>
          <img
            src={IconCloseModal}
            alt="close"
            className={style.closeModalButton}
            onClick={onRequestClose || turnOff}
          />
        </div>
      )}
    </CenterModal>
  );
};

export const CommonModal = React.memo(_CommonModal);
